<template>
	<div id="page">

		<Header></Header>

		<div class="swiper-container swiper-container-1" id="pc-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in focus_ads" :key="item.id"><img :src="adImgPrefix + item.img_url" /></div>
			</div>
			<div class="swiper-button-next swiper-button-next-1" v-if="focus_ads_count > 1"></div>
			<div class="swiper-button-prev swiper-button-prev-1" v-if="focus_ads_count > 1"></div>
		</div>

		<div class="swiper-container swiper-container-2" id="mobile-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in mobile_focus_ads" :key="item.id"><img :src="adImgPrefix + item.img_url" /></div>
			</div>
			<div class="swiper-pagination-2" v-if="mobile_focus_ads_count > 1"></div>
		</div>

		<div class="swiper-container swiper-container-ipad" id="ipad-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="item in focus_ads" :key="item.id"><img :src="adImgPrefix + item.img_url" /></div>
			</div>
			<div class="swiper-button-next swiper-button-next-ipad" v-if="focus_ads_count > 1"></div>
			<div class="swiper-button-prev swiper-button-prev-ipad" v-if="focus_ads_count > 1"></div>
		</div>

		<div id="home-product">
			<div class="container">
				<div class="title">
					<p class="p1">{{$t('h.index.product_category_title')}}</p>
					<p class="p2">{{$t('h.index.product_category_desc1')}}<br>{{$t('h.index.product_category_desc2')}}</p>
				</div>
				<ul>
					<li v-for="item in product_categorys" :key="item.id" v-if="item.img_url">
						<div class="img">
						  <router-link :to="'/product/'+item.id+'.html'" class="moreBtn">
							<img :src="pcImgPrefix + item.img_url">
						  </router-link>
						</div>
						<div class="txt">
							<h2>{{ item.cname }}</h2>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div id="mobile-home-product">
			<div class="title">{{$t('h.index.product_category_title')}}</div>
			<h3>{{$t('h.index.product_category_desc1')}}<br>
{{$t('h.index.product_category_desc2')}}</h3>
			
			<div class="swiper-container-3">
				<div class="product-hd swiper-wrapper">
					<span v-for="item in product_categorys" :key="item.id" v-if="item.m_img_url" class="swiper-slide">{{ item.cname }}</span>
				</div>
			</div>
			<div class="product-bd swiper-container swiper-container-4">
				<ul class="swiper-wrapper">
					<li v-for="item in product_categorys" :key="item.id" v-if="item.m_img_url" class="swiper-slide">
						<router-link :to="'/product/'+item.id+'.html'" class="moreBtn">
						  <img :src="pcImgPrefix + item.m_img_url">
						</router-link>
						<p>{{ item.short_desc }}</p>
					</li>
				</ul>
				<!-- <div class="swiper-pagination swiper-pagination-3"></div> -->
			</div>
			
		</div>

		<div id="advantage">
			<div class="container">
				<div class="title">
					<p class="p1">{{$t('h.index.our_advantage_title')}}</p>
					<p class="p2">{{$t('h.index.our_advantage_desc1')}}<br>{{$t('h.index.our_advantage_desc2')}}</p>
				</div>
				<ul>
					<li>
						<div class="num"><b class="num_b" data-counter-time="2000" data-counter-delay="50">30</b><small>+</small></div>
						<p>多年企业历史</p>
					</li>
					<li>
						<div class="num"><b class="num_b" data-counter-time="2000" data-counter-delay="50">80</b><small>+</small></div>
						<p>台先进设备</p>
					</li>
					<li>
						<div class="num"><b class="num_b" data-counter-time="2000" data-counter-delay="50">200</b><small>+</small></div>
						<p>专业团队</p>
					</li>
					<li>
						<div class="num"><b class="num_b" data-counter-time="2000" data-counter-delay="50">500</b><small>+</small></div>
						<p>合作客户</p>
					</li>
				</ul>
			</div>
		</div>

		<div id="mobile-advantage">
			<div class="title">我们的优势</div>
			<h3>始终以客户需求为重心，不断追求技术创新和运作卓越，<br>
			努力成为品牌客户持续发展的首选合作供应商</h3>
			<div class="num">
				<ul>
					<li>
						<div class="img">
							<img :src="imgPrefix + 'static/m-num-01.jpg'">
						</div>
					</li>
					<li>
						<div class="img">
							<img :src="imgPrefix + 'static/m-num-02.jpg'">
						</div>
					</li>
					<li>
						<div class="img">
							<img :src="imgPrefix + 'static/m-num-03.jpg'">
						</div>
					</li>
					<li>
						<div class="img">
							<img :src="imgPrefix + 'static/m-num-4.jpg'">
						</div>
					</li>
				</ul>
			</div>

			<div class="imgs">
				<ul>
					<li>
						<router-link to="/about.html">
							<div class="img">
								<img :src="imgPrefix + 'static/m-about-01.jpg'">
							</div>
							<p>企业简介</p>
						</router-link>
					</li>
					<li>
						<router-link to="/strength.html">
							<div class="img">
								<img :src="imgPrefix + 'static/m-about-02.png'">
							</div>
							<p>生产实力</p>
						</router-link>
					</li>
					<li>
						<router-link to="/service.html">
							<div class="img">
								<img :src="imgPrefix + 'static/m-about-03.png'">
							</div>
							<p>专业服务</p>
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<div id="home-about">
			<div class="container">
				<div class="left-img">
					<router-link to="/about.html">
						<img :src="imgPrefix + 'static/home_about_01.jpg'">
						<p>企业简介</p>
						<div class="idxMask"><span>企业简介</span></div>
					</router-link>

				</div>
				<div class="right-img">
					<div class="img">
						<router-link to="/strength.html">
							<img :src="imgPrefix + 'static/home_about_02.jpg'">
							<p>生产实力</p>
							<div class="idxMask"><span>生产实力</span></div>
						</router-link>
					</div>
					<div class="img">
						<router-link to="/service.html">
							<img :src="imgPrefix + 'static/home_about_03.jpg'">
							<p>专业服务</p>
							<div class="idxMask"><span>专业服务</span></div>
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<div id="home-news">
			<h2>{{$t('h.index.latest_news_title')}}</h2>
			<div class="container">
				<div class="newsImg" v-for="(item,index) in latest_news" :key="item.id" v-if="index == 0">
					<router-link :to="'/news/detail-' + item.news_category + '-' + item.id + '.html'">
            <img :src="newsImgPrefix + item.news_s_img">
						<p>{{ item.news_title }}</p>
					</router-link>
				</div>
				<div class="newsList">
					<ul>
						<li v-for="(item,index) in latest_news" :key="item.id" v-if="index >= 1 && index <= 3">
							<router-link :to="'/news/detail-' + item.news_category + '-' + item.id + '.html'">
								<div class="img"><img :src="newsImgPrefix + item.news_s_img"></div>
								<div class="txt">
									<h3>{{ item.news_title }}</h3>
									<!--<p>{{ item.news_category_name }}</p>-->
									<p v-html="item.news_content"></p>
									<!-- <div class="time">{{ item.news_display_date }}</div> -->
								</div>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';

  import { getFocusAdList, getProductCategoryList, getNewsList } from '../axios/api';

	export default {
    name: 'Index',
		data() {
			return {
        isMobile: false,
        imgPrefix: process.env.PREFIX_IMG,
        pcImgPrefix: process.env.PREFIX_IMG + 'productCategory/',
        product_categorys: [],
        adImgPrefix: process.env.PREFIX_IMG + 'gg/',
        focus_ads: [],
        focus_ads_count: 0,
        mobile_focus_ads: [],
        mobile_focus_ads_count: 0,
        newsImgPrefix: process.env.PREFIX_IMG + 'news/',
        latest_news: [],
				swiperOptionBig: {
				  autoplay: 3000,
				}
			}
		},
		components: {
			Header,
			Footer
		},

		mounted(){

		this.handleResize();

        getFocusAdList({'filter_params': {categoryId: 1, 'state': 1}}).then(response => {
          this.focus_ads = response.data.data.list;
          this.focus_ads_count = response.data.data.total;
        }).catch(error => {
				console.log('请求异常信息：'+error);
		});

        getFocusAdList({'filter_params': {categoryId: 2, 'state': 1}}).then(response => {
          this.mobile_focus_ads = response.data.data.list;
          this.mobile_focus_ads_count = response.data.data.total;
		  this.$nextTick(function(){
		  	this.bannerSwiper();
		  })
        }).catch(error => {
				console.log('请求异常信息：'+error);
		});


      getProductCategoryList({'filter_params': {'display_state': 1}}).then(response => {
        this.product_categorys = response.data.data.list;
		this.$nextTick(function(){
			this.productSwiper();
		})
      }).catch(error => {
				console.log('请求异常信息：'+error);
		});
      getNewsList({'pageSize': 4, 'filter_params': {'news_category': '3', 'news_display': 1, 'news_recommend': 1}}).then(response => {
        this.latest_news = response.data.data.list;
      }).catch(error => {
				console.log('请求异常信息：'+error);
		});

		
		
	
  //     setTimeout(function(){
		
		
		// }, 600);

		},

		methods: {
			handleResize(e) {
			   this.isMobile = document.documentElement.clientWidth < 768;
			},
			bannerSwiper:function(){
				var pcBanner = new Swiper ('.swiper-container-1', {
				    autoplay: 3000,
				    nextButton: '.swiper-button-next-1',
				    prevButton: '.swiper-button-prev-1',
				});
				
				var mobileBanner = new Swiper ('.swiper-container-2', {
				  autoplay: 3000,
				  pagination: '.swiper-pagination-2',
				  paginationClickable: true
				});
				
				var ipadBanner = new Swiper ('.swiper-container-ipad', {
				  autoplay: 3000,
				  nextButton: '.swiper-button-next-ipad',
				  prevButton: '.swiper-button-prev-ipad',
				});
			},
			productSwiper:function(){
				var aboutSwiperTab = new Swiper ('.swiper-container-3', {
				  initialSlide: 0,
				  slidesPerView : 3.5,
				  loop:true,
				  loopedSlides: 6,
				  slideToClickedSlide: true,
				  touchRatio: 0.2,
				  items:0,
				  speed:500,
				});
				
				var aboutSwiperImg = new Swiper ('.swiper-container-4', {
				  loop: true,
				  loopedSlides: 6,
				  speed:500,
				  onSlideChangeStart: function(swiper){
				    aboutSwiperTab.slideTo(swiper.activeIndex, 500, false)
				  }
				});
				aboutSwiperTab.on('slideChangeStart', function (swiper) {
				  aboutSwiperImg.slideTo(swiper.activeIndex, 500, false)
				});
			}
		},
	}
</script>

<style type="text/css" scoped>
	li {
		list-style: none;
	}

	ul {
		padding: 0;
		margin-bottom: 0;
	}
	
	#ipad-banner .swiper-slide{
		height: 0;
		opacity: 0;
	}
	
	#ipad-banner .swiper-slide-active{
		opacity: 1 !important;
	}

	.product-hd .swiper-slide-active {
		background: #ff6600 !important;
		color: #fff !important;
		
	}

	
	
	#ipad-banner .swiper-slide img{
		width: 160%;
		margin-left: -30%;
	}
	
	

	#ipad-banner .swiper-slide-active{
		height: auto;
	}

	#ipad-banner .swiper-wrapper{
		display: flex;
		display: -webkit-flex;
	}

	/* #ipad-banner{
		display: flex !important;
	} */

	#mobile-banner {
		display: none;
	}

	#ipad-banner {
		height: 0;
	}

	/* #ipad-banner {
		display: none;
	} */

	.swiper-button-next {
		background-image: url('https://img.ds-cy.com/static/swiper-button-next.png');
		right: 55px;
		left: auto;
	}

	.swiper-button-prev {
		background-image: url('https://img.ds-cy.com/static/swiper-button-prev.png');
		left: 55px;
		right: auto;
	}

	.swiper-button-next,
	.swiper-button-prev {
		position: absolute;
		top: 50%;
		width: 78px;
		height: 78px;
		margin-top: -39px;
		z-index: 10;
		cursor: pointer;
		background-size: 78px 78px;
		background-position: center;
		background-repeat: no-repeat;
		transition: all linear 200ms;
	}

	.swiper-button-next:hover {
		right: 40px;
	}

	.swiper-button-prev:hover {
		left: 40px;
	}

	.newsList {
		width: 52.5%;
		float: left;
	}

	.newsList ul li {
		min-height: 0;
		overflow: hidden;
		border-bottom: 1.5px dashed #cccccc;
		padding-bottom: 17px;
		margin-bottom: 30px;
		cursor: pointer;
	}

	/* .newsList ul li:hover img {
		transform: scale(1.1);
	} */

	.newsList ul li:hover h3{
		color: #00A0E9;
	}

	.newsImg {
		width: 44%;
		float: right;
		position: relative;
		overflow: hidden;
	}

	.newsImg:hover img {
		transform: scale(1.1);
	}

	.newsImg p {
		position: absolute;
		height: 50px;
		line-height: 50px;
		background: rgba(0, 0, 0, .6);
		color: #fff;
		text-indent: 20px;
		margin-bottom: 0;
		width: 100%;
		bottom: 0;
	}

	.newsImg img {
		width: 100%;
		transition: all linear 200ms;
	}

	.newsList ul li .img {
		width: 146px;
		float: left;
		margin-right: 25px;
		overflow: hidden;
	}

	.newsList ul li .img img {
		width: 100%;
		height: auto;
		transition: all linear 200ms;
	}

	.newsList ul li h3 {
		font-weight: normal;
		color: #333333;
		font-size: 22px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		transition: all linear 200ms;
	}

	.newsList ul li p {
		font-size: 14px;
		margin-bottom: 8px;
		color: #666666;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		max-height: 42px;
	}

	.time {
		color: #999999;
		float: right;
	}

	#home-news {
		margin-bottom: 43px;
		min-height: 0;
		overflow: hidden;
	}

	#home-news h2 {
		text-align: center;
		font-size: 42px;
		color: #333333;
		margin-top: 60px;
		margin-bottom: 68px;
	}

	#home-about {
		background: #eeeeee;
		min-height: 0;
		overflow: hidden;
		padding: 50px 0;
	}

	#home-about .left-img {
		width: 43%;
		float: left;
		position: relative;
		overflow: hidden;
	}

	#home-about .left-img img {
		transition: all linear 200ms;
	}

	/* #home-about .left-img:hover img {
		transform: scale(1.1);
	}
 */
	#home-about .left-img p {
		font-size: 24px;
		color: #ffffff;
		position: absolute;
		bottom: 25px;
		left: 30px;
		margin-bottom: 0;
		transition: all linear 200ms;
	}

	#home-about .left-img:hover p{
		opacity: 0;
	}

	#home-about .left-img img {
		width: 100%;
	}

	#home-about .right-img {
		float: right;
		width: 54.5%;
	}

	/* #home-about .right-img .img:hover img {
		transform: scale(1.1);
	} */

	#home-about .right-img .img {
		position: relative;
		margin-bottom: 28px;
		overflow: hidden;
	}

	#home-about .right-img .img .idxMask{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		background: rgba(0,0,0,.5);
		left: 0;
		opacity: 0;
		-webkit-transition: all linear 200ms;
		transition: all linear 200ms;
		text-align: center;
	}

	#home-about .right-img .img:hover .idxMask{
		opacity: 1;
	}

	#home-about .right-img .img span {
	    font-size: 26px;
	    padding: 6px 13px;
	    display: inline-block;
	    border: 2px solid hsla(0,0%,100%,0);
	    color: hsla(0,0%,100%,0);
	    transform: scale(0);
	    -ms-transform: scale(0);
	    -moz-transform: scale(0);
	    -webkit-transform: scale(0);
	    -o-transform: scale(0);
	    -webkit-transition: all .5s ease;
	    transition: all .5s ease;
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    margin-top: -27px;
	    margin-left: -67px;
	}

	#home-about .right-img .img:hover span{
	    border: 2px solid #fff;
	    color: #fff;
	    transform: scale(1);
	    -ms-transform: scale(1);
	    -moz-transform: scale(1);
	    -webkit-transform: scale(1);
	    -o-transform: scale(1);
	}

	#home-about .right-img .img:last-of-type {
		margin-bottom: 0;
	}

	#home-about .right-img img {
		width: 100%;
		transition: all linear 200ms;
	}

	#home-about .right-img p {
		position: absolute;
		bottom: 25px;
		left: 35px;
		margin-bottom: 0;
		color: #fff;
		font-size: 24px;
		transition: all linear 200ms;
	}

	#home-about .right-img .img:hover p{
		opacity: 0;
	}


	#banner img {
		width: 100%;
	}

	#home-product {
		margin: 80px auto 65px auto;
		min-height: 0;
		overflow: hidden;
	}

	#home-product .title {
		text-align: center;
		margin-bottom: 63px;
	}

	#home-product .title .p1 {
		font-size: 42px;
		color: #333333;
		margin-bottom: 10px;
	}

	#home-product .title .p2 {
		color: #666666;
		line-height: 28px;
	}

	#home-product ul li {
		float: left;
		margin-right: 30px;
		width: 32%;
		margin-right: 2%;
		position: relative;
		margin-bottom: 2%;
		cursor: pointer;
	}

	#home-product ul li img {
		width: 100%;
		transition: all linear 200ms;
	}

	#home-product ul li .img {
		overflow: hidden;
	}

	#home-product ul li:hover img {
		transform: scale(1.1);
	}

	#home-product ul li .txt {
		position: absolute;
		bottom: 20px;
		left: 25px;

	}

	#home-product ul li .txt h2 {
		font-size: 28px;
		color: #ffffff;
		padding-bottom: 20px;
		position: relative;
	}

	#home-product ul li .txt h2::after{
		content: '';
		width: 52px;
		height: 4px;
		left: 0;
		bottom: 0;
		background: #00b7ff;
		position: absolute;
	}

	#home-product ul li .txt p {
		margin-bottom: 0;
		color: #ffffff;
		font-size: 16px;
	}

	#home-product ul li:nth-child(3n) {
		margin-right: 0;
	}

	#advantage {
		margin-bottom: 50px;
	}

	#advantage .title {
		text-align: center;
	}

	#advantage .title .p1 {
		font-size: 42px;
		color: #333333;
	}

	#advantage .title .p2 {
		font-size: 18px;
		color: #666666;
		line-height: 28px;
		margin-bottom: 60px;
	}

	#advantage {
		min-height: 0;
		overflow: hidden;
	}

	#advantage ul {
		text-align: center;
	}

	#advantage ul li {
		width: 230px;
		height: 230px;
		border: 2px solid #f5f5f5;
		border-radius: 50%;
		display: inline-block;
		margin: 0 30px;
	}

	#advantage ul li .num {
		font-size: 70px;
		color: #ff3300;
		margin-bottom: 20px;
		position: relative;
		margin-top: 10px;
	}

	#advantage ul li .num small {
		font-size: 35px;
		font-weight: bold;
		position: absolute;
		top: 40px;
	}

	#advantage ul li .num b {
		position: relative;
		top: 28px;
	}

	#advantage ul li .num_b {
		font-weight: 500;
	}

	#advantage ul li p {
		font-size: 18px;
		color: #666666;
	}

	.swiper-slide img {
		width: 100%;
	}

	#mobile-home-product {
		margin: 20px 0 30px 0;
		display: none;
		overflow: hidden;
	}

	#mobile-home-product .title {
		margin-bottom: 12px;
	}

	#mobile-home-product h3{
		font-size: 11px;
		text-align: center;
		color: #666666;
		line-height: 18px;
		margin-bottom: 24px;
	}

	#mobile-home-product .product-hd {
		line-height: 44px;
		height: 44px;
		/* min-height: 0;
		overflow: hidden; */
	}

	#mobile-home-product .product-hd span {
		display: block;
		float: left;
		/* width: 25%; */
		text-align: center;
		background: #393939;
		color: #fff;
		font-size: 15px;
	}

	#mobile-home-product .product-hd span.active {
		background: #ff6600;
	}

	#mobile-home-product ul li img {
		width: 100%;
	}

	#mobile-home-product ul li p{
		text-align: center;
		margin-bottom: 0;
		background: #666666;
		color: #fff;
		text-align: center;
		font-size: 12px;
		line-height: 46px;
	}

	#mobile-home-product .title {
		text-align: center;
		font-size: 22px;
		color: #333333;
		margin-top: 20px;
	}

	#mobile-advantage {
		min-height: 0;
		overflow: hidden;
		display: none;
	}

	#mobile-advantage .title {
		text-align: center;
		font-size: 22px;
		margin-bottom: 10px;
		padding-top: 10px;
	}

	#mobile-advantage  h3{
		font-size: 11px;
		text-align: center;
		color: #666666;
		line-height: 18px;
		margin-bottom: 24px;
	}

	#mobile-advantage .num {
		min-height: 0;
		overflow: hidden;
		margin-top: 35px;
	}

	#mobile-advantage .num ul {
		width: 94%;
		margin-left: 3%;
	}

	#mobile-advantage .num ul li {
		width: 25%;
		float: left;
		text-align: center;
		position: relative;
		margin-bottom: 20px;
	}

	#mobile-advantage .num ul li p {
		font-size: 14px;
		color: #666666;
		padding-top: 5px;
	}

	#mobile-advantage .num{
		width: 90%;
		margin-left: 5%;
		margin-bottom: 25px;
	}

	#mobile-advantage .num ul li .img {
		display: block;
		width: 82%;
		margin-left: 9%;
	}

	#mobile-advantage .num ul li .img img {
		width: 100%;
	}

	#mobile-advantage .imgs {
		padding: 0 3%;
		min-height: 0;
		overflow: hidden;
		margin-bottom: 20px;
		margin-top: 8px;
	}

	#mobile-advantage .imgs img {
		width: 100%;
	}

	#mobile-advantage .imgs ul li {
		position: relative;
		margin-bottom: 3%;
		position: relative;
	}

	#home-about .left-img .idxMask{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		background: rgba(0,0,0,.5);
		left: 0;
		opacity: 0;
		transition: all linear 200ms;
		text-align: center;
	}

	#home-about .left-img:hover .idxMask{
		opacity: 1;
	}

	#home-about .left-img span{
	    font-size: 26px;
	    padding: 6px 13px;
	    display: inline-block;
	    border: 2px solid hsla(0,0%,100%,0);
	    color: hsla(0,0%,100%,0);
	    transform: scale(0);
	    -ms-transform: scale(0);
	    -moz-transform: scale(0);
	    -webkit-transform: scale(0);
	    -o-transform: scale(0);
	    -webkit-transition: all .5s ease;
	    -o-transition: all .5s ease;
	    transition: all .5s ease;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -27px;
		margin-left: -67px;
	}


	#home-about .left-img:hover span{
	    border: 2px solid #fff;
	    color: #fff;
	    transform: scale(1);
	    -ms-transform: scale(1);
	    -moz-transform: scale(1);
	    -webkit-transform: scale(1);
	    -o-transform: scale(1);
	}

	#mobile-advantage .imgs ul li:nth-child(2) {
		width: 48.5%;
		float: left;
	}

	#mobile-advantage .imgs ul li:nth-child(3) {
		width: 48.5%;
		float: right;
	}

	#mobile-advantage .imgs ul li p {
		position: absolute;
		width: 100%;
		height: 40px;
		line-height: 40px;
		background: rgba(0, 0, 0, .5);
		bottom: 0;
		left: 0;
		margin-bottom: 0;
		color: #ffffff;
		text-indent: 10px;
	}

	#pc-banner{
		min-height: 200px;
	}

	#home-product{
		min-height: 500px;
	}

	@media (max-width:1439px) {
		.newsList ul li h3 {
			font-size: 19px;
		}

		.newsList ul li {
			padding-bottom: 12px;
			margin-bottom: 12px;
		}

		.newsList ul li .img {
			width: 130px;
		}

		.newsList ul li p {
			font-size: 13px;
			-webkit-box-orient: vertical;
			max-height: 38px;
		}

		.newsList ul li .time {
			font-size: 14px;
		}

		#advantage ul li {
			width: 200px;
			height: 200px;
		}

		#advantage ul li .num {
			font-size: 60px;
		}
	}


	@media (max-width:1199px) {
		#advantage ul li {
			width: 170px;
			height: 170px;
			margin: 0 28px;
		}

		#advantage ul li .num {
			font-size: 50px;
			margin-top: 0;
		}

		#advantage ul li p {
			font-size: 16px;
		}

		#home-about .left-img {
			width: 43%;
		}

		#home-about .right-img .img {
			margin-bottom: 20px;
		}

		#home-product .title {
			margin-bottom: 40px;
		}

		#advantage .title .p2 {
			margin-bottom: 50px;
		}

		.newsList ul li .img {
			width: 110px;
			margin-right: 15px;
		}

		.newsList ul li p {
			-webkit-line-clamp: 1;
		}

		.newsImg {
			width: 45%;
		}
	}

	@media (max-width:992px) {

		/* #mobile-home-product{
			display: block;
		} */

		#advantage ul li {
			width: 145px;
			height: 145px;
			margin: 0px 10px;
		}

		#advantage ul li .num {
			font-size: 44px;
			margin-top: 2px;
			margin-bottom: 12px;
		}

		#advantage ul li .num b {
			top: 18px;
		}

		#advantage ul li .num small {
			top: 18px;
		}

		#home-product ul li .txt h2 {
			font-size: 24px;
		}

		#home-product ul li .txt p {
			font-size: 14px;
		}

		#home-product ul li .txt {
			bottom: 15px;
		}

		#home-product .title .p1 {
			font-size: 36px;
		}

		.newsList ul li p {
			display: none;
		}

		.newsList ul li .img {
			width: 75px;
		}

		.newsList ul li h3 {
			font-size: 15px;
		}

		#home-news h2 {
			font-size: 36px;
			margin-bottom: 45px;
			margin-top: 50px;
		}

		#advantage .title .p1 {
			font-size: 36px;
		}

		#home-product {
			margin: 65px auto 50px auto;
		}

		#advantage .title .p2 {
			font-size: 17px;
		}

		#advantage .title .p2 {
			margin-bottom: 40px;
		}

		#home-about .right-img .img {
			margin-bottom: 15px;
		}


		#pc-banner {
			display: none;
		}
		#ipad-banner {
			height: auto;
		}
		#mobile-banner {
			display: none;
		}
	}

	@media (max-width:767px) {
		#mobile-home-product .product-hd span{
			width: 28.6%;
		}
		#pc-banner {
			display: none;
		}
		#ipad-banner {
			display: none;
		}
		#mobile-banner {
			display: block;
		}
		#mobile-advantage .num ul li{
			width: 50%;
		}
		#mobile-advantage {
			display: block;
		}

		#mobile-home-product {
			display: block;
		}

		#advantage .title .p2 {
			display: none;
		}

		#home-about {
			display: none;
		}

		#advantage {
			display: none;
		}

		#home-product {
			display: none;
		}

		#home-news {
			background: #e5e5e5;
			margin-bottom: 0;
			padding-bottom: 40px;
			margin-top: 5px;
		}

		.newsImg {
			width: 100%;
		}

		.newsList {
			width: 100%;
			background: #fff;
			padding: 10px;
		}

		.newsList ul li {
			border-bottom: 1px dashed #cccccc;
		}

		.newsList ul li:last-child {
			border: none;
			margin-bottom: 0;
			padding-bottom: 2px;
		}

		.newsList ul li .img {
			width: 100px;
		}

		.newsList ul li .time {
			float: left;
		}

		.newsList ul li h3 {
			font-size: 15px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			white-space: inherit;
			line-height: 20px;
			height: 43px;
		}

		#home-news h2 {
			font-size: 22px;
			margin-bottom: 20px;
			margin-top: 35px;
		}

		.newsImg p {
			text-indent: 10px;
			height: 46px;
			line-height: 46px;
		}


		.newsImg img{
			margin-top: -40px;
			margin-bottom: -40px;
		}
		#mobile-home-product ul li p{
			height: 46px;
			overflow: hidden;
			font-size: 11px;
		}
	}
	@media (max-width:350px) {
		#mobile-home-product{
			margin-bottom: -10px;
		}
	}
</style>

<style>
	.swiper-pagination-2 {
		position: absolute;
		z-index: 99;
		text-align: center;
		bottom: 15px !important;
	}

	.swiper-pagination-2 .swiper-pagination-bullet {
		width: 50px !important;
		height: 3px !important;
		border-radius: 0 !important;
		background: #ffffff !important;
		opacity: 1 !important;
		margin: 0 6px !important;
	}

	.swiper-pagination-2 .swiper-pagination-bullet-active {
		background: #00b6ff !important;
	}

	.swiper-pagination-ipad .swiper-pagination-bullet {
		width: 50px !important;
		height: 3px !important;
		border-radius: 0 !important;
		background: #ffffff !important;
		opacity: 1 !important;
		margin: 0 6px !important;
	}

	.swiper-pagination-ipad .swiper-pagination-bullet-active {
		background: #00b6ff !important;
	}

	.swiper-pagination-ipad {
	    position: absolute;
	    z-index: 99;
	    text-align: center;
	    bottom: 15px !important;
	}

	.swiper-pagination-3 .swiper-pagination-bullet {
		width: 40px !important;
		height: 5px !important;
		border-radius: 30px !important;
		background: #ffffff !important;
		opacity: 1 !important;
		margin: 0 6px !important;
	}
	.swiper-pagination-3 .swiper-pagination-bullet-active {
		background: #6a6a6c !important;
	}
	
	.opacity{
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/page/index.html.vue